export const ACCEPT = {
  image: "image/png, image/jpeg, image/gif",
  document: ".xlsx, .xls, .pdf",
  imageOrDocument:
    "image/png, image/jpeg, .xlsx, .xls, .pdf, .doc, .docx, .ppt, .pptx",
  csv: "text/csv",
};

export const MAX_FILE_SIZE = 10;
